import { useState } from "react";
import Button from "./Button";
import Input from "./Input";
import { FaListUl } from "react-icons/fa";
import { BsFillGridFill } from "react-icons/bs";
import { Translate } from "react-localize-redux";

const Navigation = ({
  title,
  inputPlaceholder,
  inputOnChange,
  iconNode,
  buttonNode,
  onViewerClick,
  onButtonClick,
  extraViewerNode,
}) => {
  const [isCardView, setCardView] = useState(true);
  return (
    <div className="navigation row px-4">
      <div className="col-12 col-md-3 fw-bold pt-3">
        <span className="navigation-title">{title}</span>
      </div>
      <div className="col-12 col-md-9 d-flex flex-wrap justify-content-end align-items-center">
        {(onViewerClick || extraViewerNode) && (
          <div className="d-flex align-items-center mb-2 me-3">
            {onViewerClick && (
              <>
                <p
                  className="mb-0 border-end pe-3 py-2 cursor--pointer"
                  onClick={() => {
                    onViewerClick(true);
                    setCardView(true);
                  }}
                >
                  <BsFillGridFill
                    className={` ${isCardView ? "text-orange" : "text-gray"}`}
                  />
                </p>
                <p
                  className="mb-0 ms-3 cursor--pointer"
                  onClick={() => {
                    onViewerClick(false);
                    setCardView(false);
                  }}
                >
                  <FaListUl
                    className={` ${!isCardView ? "text-orange" : "text-gray"}`}
                  />
                </p>
              </>
            )}
            {extraViewerNode && (
              <p className="mb-0 ms-3 border-start ps-3 py-2 cursor--pointer">
                {extraViewerNode}
              </p>
            )}
          </div>
        )}
        {inputOnChange && inputPlaceholder && (
          <div className="d-flex mx-4 mb-2">
            <p className="mt-3 me-2">
              <Translate id="filter" />:
            </p>
            <Input
              type="text"
              placeholder={inputPlaceholder}
              iconNode={iconNode}
              onChange={inputOnChange}
            />
          </div>
        )}
        {buttonNode && (
          <Button
            className="btn-blue mb-2 py-2"
            onClick={() => onButtonClick()}
          >
            {buttonNode}
          </Button>
        )}
      </div>
    </div>
  );
};

export default Navigation;
